import { takeEvery } from '@redux-saga/core/effects'
import { NotificationActions } from './Notification.actions'
import { addAutoFadeNotification } from './Notification.effects'

function* addAutoFadeNotificationSaga() {
  yield takeEvery(NotificationActions.ADD_AUTO_FADE_NOTIFICATION, addAutoFadeNotification)
}

export const NotificationEffects = [addAutoFadeNotificationSaga()]
